import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { ERROR_CODES } from '../../../configs';
import { FormRoutes, FraudFormOrigins } from '../../../libs/enums';

const CODES = ERROR_CODES as unknown as Record<string, string>;

export const useSupportPage = () => {
  const navigate = useNavigate();

  const submitHandler = useCallback(
    ({
      errorCodeSelect,
      fraudSurveyOriginSelect,
    }: {
      errorCodeSelect: string;
      fraudSurveyOriginSelect: string;
    }) => {
      // @NOTE : conditions must be refactored
      // use a helpers/utils/service to get the formtype dans formroute
      // @see https://gitlab.dev-franceconnect.fr/france-connect/formulaire-usagers/-/merge_requests/62#note_210233
      if (errorCodeSelect) {
        const formtype = CODES[errorCodeSelect];
        if (formtype) {
          const formroute = FormRoutes[formtype.toUpperCase() as keyof typeof FormRoutes];
          const url = `/formulaire/${formroute}/${errorCodeSelect}`;
          navigate(url);
        }
      } else if (fraudSurveyOriginSelect) {
        const url = `/formulaire/${FormRoutes.FRAUD}/${fraudSurveyOriginSelect}`;
        navigate(url);
      }
    },
    [navigate],
  );

  const memoizedErrorCodes = useMemo(() => {
    const allValues = Object.keys(ERROR_CODES).map((key) => ({
      label: key.toUpperCase(),
      value: key,
    }));
    return allValues;
  }, []);

  const memoizedFraudSurveyOrigins = useMemo(() => {
    const allValues = Object.keys(FraudFormOrigins).map((key) => ({
      label: key.toLowerCase(),
      value: key.toLowerCase(),
    }));
    return allValues;
  }, []);

  return { memoizedErrorCodes, memoizedFraudSurveyOrigins, submitHandler };
};
